var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"animated",attrs:{"show":_vm.loading}},[_c('v-server-table',{ref:_vm.ref,staticClass:"w-100",attrs:{"columns":_vm.table_config.columns,"options":_vm.table_config.options,"theme":_vm.theme,"id":"service-question-server-table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }